import { render, staticRenderFns } from "./EmpleadoPrimaVacacional.vue?vue&type=template&id=60a66dd7&"
import script from "./EmpleadoPrimaVacacional.vue?vue&type=script&lang=js&"
export * from "./EmpleadoPrimaVacacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports